import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '../api-client.ts';

export const useDeletePattern = (projectUuid: string) => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, string>({
    mutationFn: (uuid) => apiClient.delete(`/v1/projects/${projectUuid}/patterns/${uuid}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['patterns', projectUuid] });
    },
  });
};
